import { connect } from 'react-redux';
import { compose, hoistStatics, withHandlers, withState } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import RightSide from './RightSide';

const mapStateToProps = state => ({
  user: state.user.user,
  pageTitle: state.settings.pageTitle,
  pageSubTitle: state.settings.pageSubTitle,
  backgroundPage: state.settings.backgroundPage,
  backgroundCover: state.settings.backgroundCover,
});

const buttonCssClass = 'hamburger hamburger--squeeze';

const toggleMenu = props => (e) => {
  e.preventDefault();
  const { menuIcon, setMenuIcon, setShowMenu } = props;
  const showMenu = menuIcon === buttonCssClass;
  setMenuIcon(showMenu ? `${menuIcon} is-active` : buttonCssClass);
  setShowMenu(showMenu);
};

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('menuIcon', 'setMenuIcon', buttonCssClass),
  withState('showMenu', 'setShowMenu', 0),
  withHandlers({
    toggleMenu,
  }),
);

export default withRouter(hoistStatics(enhance)(RightSide));



// WEBPACK FOOTER //
// ./src/views/modules/blog/rightSide/index.js